import { useSandboxPreview } from "@/contexts/SandboxPreviewContext";
import { Button } from "@/components/ui/button";
import { FlaskConical, X } from "lucide-react";

export function SandboxBanner() {
  const { preview, exitPreview } = useSandboxPreview();
  if (!preview) return null;
  return (
    <div className="sticky top-0 z-[100] w-full bg-amber-500 text-amber-950 border-b border-amber-700 shadow-md">
      <div className="container mx-auto flex items-center justify-between gap-3 px-4 py-2 text-sm font-medium">
        <div className="flex items-center gap-2 min-w-0">
          <FlaskConical className="h-4 w-4 shrink-0" />
          <span className="truncate">
            Sandbox preview — <strong>{preview.feature_name}</strong> · Role: <strong>{preview.role}</strong> · PTA: <strong>{preview.pta_name}</strong>
          </span>
        </div>
        <Button size="sm" variant="outline" className="h-7 bg-white/90 hover:bg-white border-amber-700" onClick={exitPreview}>
          <X className="h-3.5 w-3.5 mr-1" /> Exit preview
        </Button>
      </div>
    </div>
  );
}
